/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateInstrumentSelectionRequest} from '@cash-web/protos/squareup/cash/moneta/api/v1_0/InstrumentSelection.pb'
import {InitiateInstrumentSelectionResponse} from '@cash-web/protos/squareup/cash/moneta/api/v1_0/InstrumentSelection.pb'


export const initiateCashInInstrumentSelection = (request: InitiateInstrumentSelectionRequest, options?: CashRequestOptions) => post<InitiateInstrumentSelectionRequest, InitiateInstrumentSelectionResponse>("/cash-app/cash-in/v1.0/initiate-cash-in-instrument-selection", request, {...options, rejectOnError: true })